import React from 'react';
import { ErrorBoundary, ErrorBoundaryPanel, useLogging } from '@workday/upc-common';
import { loginActions } from '../slices/login.slice';
import { environment } from '../../environments/environment';
import { useDispatch } from 'react-redux';
import { LOGIN_PATH } from '../react-router-paths';
import { useTranslation } from 'react-i18next';

export interface WclErrorBoundaryProps {
    children: React.ReactNode;
    logoutOnError?: boolean;
}

export function WclErrorBoundary({ children, logoutOnError = true }: WclErrorBoundaryProps) {
    const dispatch = useDispatch();
    const loggedIn = localStorage.getItem('loggedIn') === 'true';
    const { logger } = useLogging();
    const { t } = useTranslation('auth');
    const signOutUser = () => {
        dispatch(loginActions.logout());
    };

    const onErrorCatch = error => {
        logger?.error({
            message: error.message,
            stackTrace: error.stack
        });

        // Attempt to clear session data
        if (loggedIn && logoutOnError) {
            signOutUser();
        }
    };

    return (
        <ErrorBoundary
            fallbackRender={() => (
                <ErrorBoundaryPanel
                    title={t('ErrorBoundary.somethingWentWrongTitle')}
                    description={t('ErrorBoundary.weAreWorkingDescription')}
                    returnButtonProps={{
                        text: t('ErrorBoundary.returnToLoginButtonText'),
                        onClick: () => {
                            window.location.href = LOGIN_PATH;
                        }
                    }}
                />
            )}
            onErrorCatch={onErrorCatch}
            disabled={!environment.enableErrorBoundary}>
            {children}
        </ErrorBoundary>
    );
}
